<template lang="pug">
  div#app
    v-app
      Header
      Filters
      router-view
      notifications(group="foo", position="top right")
      Footer

</template>

<style lang="scss">
@import "./styles.scss";
</style>

<script>
import Header from "./components/Header";
import Filters from "./components/Filters";
import Footer from "./components/Footer";
import $data from "@/services/data.services.js";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Filters
  },
  data() {
    return {
      //
    };
  },
  async created() {
    await $data.getData();
  }
};
</script>
